export default __webpack_public_path__ + "static/media/familyMemberImg.885099c0.webp";